import { VImg } from 'vuetify/lib/components/VImg';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.CoreDrawer,
    {
      attrs: {
        value: _vm.value,
        width: 667,
        title: "Клуб ПроДокторов",
        attach: _vm.attach,
      },
      on: {
        input: function ($event) {
          return _vm.$emit("input", $event)
        },
      },
      scopedSlots: _vm._u([
        {
          key: "title-append",
          fn: function () {
            return [
              _c(VImg, {
                staticClass: "ml-2",
                attrs: {
                  src: "/static/_v1/pd/icons/ui-kit/club/club-percent.svg",
                  width: "24",
                  height: "24",
                  alt: "Иконка Процент Клуба",
                },
              }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(_setup.ClubInfoComponent, {
        tag: "component",
        class: _setup.isMobile ? "py-4" : "pa-6",
        attrs: {
          "pdf-data": {
            coupon:
              "/static/_v1/pd/documents/pdf/club/Правила_использования_купонов.pdf",
            participation:
              "/static/_v1/pd/documents/pdf/club/Правила_участия_в_клубе_ПроДокторов.pdf",
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }